import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import api from '../../services/api.service'

const BASE_PATH = '/lottustech/webhook/pixautomatico'
const crud = build(validate, BASE_PATH)
const prefix = 'crudWebhookPixAutomatico'

const newTypes = {
  RESET: `${prefix}reset`,
  SET_LOADING_CADASTRAR: `${prefix}setLoadingCadastrar`,
  SET_LOADING_CONSULTAR: `${prefix}setLoadingConsultar`,
  SET_LOADING_CANCELAR: `${prefix}setLoadingCancelar`,
  SET_PSP_RESPONSE: `${prefix}setPspResponse`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.setLoadingCadastrar = (loading) => {
  return {
    type: types.SET_LOADING_CADASTRAR,
    payload: loading,
  }
}

actions.setLoadingConsultar = (loading) => {
  return {
    type: types.SET_LOADING_CONSULTAR,
    payload: loading,
  }
}

actions.setLoadingCancelar = (loading) => {
  return {
    type: types.SET_LOADING_CANCELAR,
    payload: loading,
  }
}

actions.setPspResponse = (response) => {
  return {
    type: types.SET_PSP_RESPONSE,
    payload: response,
  }
}

actions.cadastrarNoPsp = (oid) => {
  return (dispatch) => {
    dispatch(actions.setLoadingCadastrar(true))
    return api
      .post(`${BASE_PATH}/${oid}/cadastrar-psp`)
      .then((response) => {
        dispatch(actions.setLoadingCadastrar(false))
        dispatch(actions.setPspResponse({ success: true, message: 'Webhook cadastrado no PSP com sucesso!' }))
        dispatch(actions.loadById(oid))
        return response
      })
      .catch((error) => {
        dispatch(actions.setLoadingCadastrar(false))
        const errorMessage = error.response?.data?.error || 'Erro ao cadastrar webhook no PSP'
        dispatch(actions.setPspResponse({ success: false, message: errorMessage }))
        throw error
      })
  }
}

actions.consultarNoPsp = (oid) => {
  return (dispatch) => {
    dispatch(actions.setLoadingConsultar(true))
    return api
      .post(`${BASE_PATH}/${oid}/consultar-psp`)
      .then((response) => {
        dispatch(actions.setLoadingConsultar(false))
        dispatch(actions.setPspResponse({ success: true, message: 'Consulta realizada com sucesso!', data: response.data }))
        return response
      })
      .catch((error) => {
        dispatch(actions.setLoadingConsultar(false))
        const errorMessage = error.response?.data?.error || 'Erro ao consultar webhook no PSP'
        dispatch(actions.setPspResponse({ success: false, message: errorMessage }))
        throw error
      })
  }
}

actions.cancelarNoPsp = (oid) => {
  return (dispatch) => {
    dispatch(actions.setLoadingCancelar(true))
    return api
      .post(`${BASE_PATH}/${oid}/cancelar-psp`)
      .then((response) => {
        dispatch(actions.setLoadingCancelar(false))
        dispatch(actions.setPspResponse({ success: true, message: 'Webhook cancelado no PSP com sucesso!' }))
        dispatch(actions.loadById(oid))
        return response
      })
      .catch((error) => {
        dispatch(actions.setLoadingCancelar(false))
        const errorMessage = error.response?.data?.error || 'Erro ao cancelar webhook no PSP'
        dispatch(actions.setPspResponse({ success: false, message: errorMessage }))
        throw error
      })
  }
}

export { types, actions }
